import { FeatureGatePage } from '../src/pages/feature-gate-page'
import { forRails } from 'components/for-rails'
import { registerComponents } from '../src/utils/react/registry'

registerComponents({
  FeatureGatePage: forRails(FeatureGatePage),
})
